import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppLocalStorage } from 'app/app-storage-manager/local-storage';
import { MiscService } from 'app/shared/misc.service';
import { environment } from 'environments/environment';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AsaDashboardResponse } from './_state/dashboard.interfaces';
@Injectable({
  providedIn: 'root'
})

export class DashboardService {
    constructor(private http: HttpClient,  private miscService: MiscService) { }

    getOutstandingBalance = () => this.http.get(`${environment.API_URL}/merchants/notsent/overview/${this.miscService.getMerchantDetails().merchant_id}`)

    getMerchantPaymentChannels = () => this.http.get(`${environment.API_URL2}/transactions-service/merchant/channels/overview/${this.miscService.getMerchantDetails().merchant_id}`)

    getChannelsProductsSummary = (channelId) => this.http.get(`${environment.API_URL}/merchant/channels/products/${channelId}/${this.miscService.getMerchantDetails().merchant_id}`)

    getMerchantEarningFromProductPerDay = (channelId, productId) => this.http.get(`${environment.API_URL}/merchants/products/overview/${this.miscService.getMerchantDetails().merchant_id}/${channelId}/${productId}`)
    
    getTransactionsFromProductPerDay = (productId, date) => this.http.get(`${environment.API_URL}/merchants/product/${productId}/${this.miscService.getMerchantDetails().merchant_id}/${date}`)

 getPendingTransactions = (txnId: string, page?: number, limit?: number) => {
  let params = new HttpParams();
  
  if (page) {
    params = params.set('page', page.toString());
  }
  
  if (limit) {
    params = params.set('limit', limit.toString());
  }
  
  const url = `${environment.MERCHANT_AUTH_URL}/api/pending/${this.miscService.getMerchantDetails().merchant_id}/${txnId}`;
  
  return this.http.get(url, { params });
}
getTransactionHistory = (txnId, status, startDate?, endDate?) => {
  let url = `${environment.MERCHANT_AUTH_URL}/api/history/${this.miscService.getMerchantDetails().merchant_id}/${txnId}/${status}`;
  
  // Add query parameters for date range if provided
  let params = new HttpParams();
  if (startDate) {
    params = params.set('startDate', startDate);
  }
  if (endDate) {
    params = params.set('endDate', endDate);
  }
  
  return this.http.get(url, { params });
}

    
    getMoveToBanksTransactionsByStatus = (status) => this.http.get(`${environment.API_URL}/merchant/${this.miscService.getMerchantDetails().merchant_id}/process/${status}`)

    getUniqueUrlForMarketPlace = ():Observable<any> => this.http.get(`${environment.API_URL}/external-auth/xmkt`)

    getDashboardData = (merchantId, isoCode, start_date, end_date, page, limit, filter, settledTransaction)=>{
      let params = new HttpParams();
    if(start_date)
      params = params.append('start_date', start_date);
    if(end_date)
      params = params.append('end_date', end_date);
    if(page)
      params = params.append('page', page);
    if(limit)
      params = params.append('limit', limit);
    // if(filter)
      params = params.append('filter_type', 'ALL');
    if(settledTransaction){
      params = params.append('settled', settledTransaction);
    }
      return this.http.get(`${environment.API_URL2}/transactions-service/merchant/dashboard/${merchantId}/${isoCode}`, { params })
    }

    getAsaDashboard = (period?: string, startDate?: string, endDate?: string, page?: number, limit?: number): Observable<AsaDashboardResponse> => {
      let params = new HttpParams();

      if (period) {
        params = params.set('period', period);
      }

      if (startDate) {
        params = params.set('startDate', startDate);
      }

      if (endDate) {
        params = params.set('endDate', endDate);
      }

      if (page) {
        params = params.set('page', page.toString());
      }

      if (limit) {
        params = params.set('limit', limit.toString());
      }

      return this.http.get<AsaDashboardResponse>(`${environment.API_URL2}/asa/admin/dashboard`, { params })
    }

}